(function () {
  if (window.__productTotalPriceInit) return;
  window.__productTotalPriceInit = true;

  var productDataCache = {};
  var BULK_QUOTE_HANDLE = 'lawn-sign-printing-toronto-custom-coroplast-yard-signs';
  var BULK_QUOTE_THRESHOLD = 100;
  var BULK_QUOTE_MESSAGE =
    'For orders of 100+ signs, please <a href="/pages/get-a-printing-quote-in-toronto">contact us for a custom quote</a>.';
  var CONTACT_ONLY_HANDLES = ['custom-tote-bags'];
  var CONTACT_ONLY_MESSAGE =
    'Starting as low as $3/bag, depending on quantity and design — every order is quoted individually. ' +
    '<a href="/pages/get-a-printing-quote-in-toronto">Contact us for a free quote</a>.';
  var BULK_QUOTE_TIERS = [
    { min: 90, percent: 0.28 },
    { min: 80, percent: 0.26 },
    { min: 70, percent: 0.24 },
    { min: 60, percent: 0.22 },
    { min: 50, percent: 0.2 },
    { min: 35, percent: 0.18 },
    { min: 25, percent: 0.15 },
    { min: 20, percent: 0.12 },
    { min: 15, percent: 0.1 },
    { min: 10, percent: 0.08 },
    { min: 6, percent: 0.05 },
  ];

  function discountPercentFor(qty) {
    for (var i = 0; i < BULK_QUOTE_TIERS.length; i++) {
      if (qty >= BULK_QUOTE_TIERS[i].min) return BULK_QUOTE_TIERS[i].percent;
    }
    return 0;
  }

  function formatMoney(cents, format) {
    if (isNaN(cents) || cents == null) cents = 0;

    function defaultTo(value, fallback) {
      return value == null || value !== value ? fallback : value;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';

      return dollars + centsPart;
    }

    var formatString = format || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholderRegex);
    var value;

    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return match ? formatString.replace(placeholderRegex, value) : formatString + value;
  }

  function getProductData(url) {
    if (!productDataCache[url]) {
      productDataCache[url] = fetch(url + '.js')
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .catch(function () {
          return null;
        });
    }
    return productDataCache[url];
  }

  function ensureTotalElement(sectionId) {
    var id = 'ProductTotalPrice-' + sectionId;
    var el = document.getElementById(id);
    if (el) return el;

    var priceEl = document.getElementById('price-' + sectionId);
    if (!priceEl || !priceEl.parentNode) return null;

    el = document.createElement('div');
    el.id = id;
    el.className = 'product-total-price caption';
    el.style.marginTop = '0.5rem';
    el.innerHTML =
      '<span class="product-total-price__label">Total: </span>' +
      '<span class="product-total-price__value"></span>' +
      '<div class="product-total-price__note caption"></div>';
    priceEl.insertAdjacentElement('afterend', el);
    return el;
  }

  function hideBuyButton(wrapper, productInfo, sectionId) {
    if (wrapper && wrapper.style.display !== 'none') wrapper.style.display = 'none';
    if (productInfo) {
      var buttons = productInfo.querySelector('.product-form__buttons');
      if (buttons && buttons.style.display !== 'none') buttons.style.display = 'none';
    }
    var priceEl = document.getElementById('price-' + sectionId);
    if (priceEl && priceEl.style.display !== 'none') priceEl.style.display = 'none';
  }

  function updateTotal(quantityInputEl) {
    if (!quantityInputEl) return;
    var wrapper = quantityInputEl.closest('quantity-input[data-url]');
    if (!wrapper) return;

    var sectionId = wrapper.dataset.section;
    var url = wrapper.dataset.url;
    if (!sectionId || !url) return;

    getProductData(url).then(function (product) {
      if (!product || !product.variants) return;

      var productInfo = wrapper.closest('product-info');

      if (product.handle && CONTACT_ONLY_HANDLES.indexOf(product.handle) !== -1) {
        hideBuyButton(wrapper, productInfo, sectionId);
        var contactEl = ensureTotalElement(sectionId);
        if (contactEl) {
          var contactValueEl = contactEl.querySelector('.product-total-price__value');
          var contactNoteEl = contactEl.querySelector('.product-total-price__note');
          if (contactValueEl) contactValueEl.textContent = '';
          if (contactNoteEl) contactNoteEl.innerHTML = CONTACT_ONLY_MESSAGE;
        }
        return;
      }

      var variantInput = productInfo ? productInfo.querySelector('input[name="id"]') : null;
      var variantId = variantInput ? parseInt(variantInput.value, 10) : null;

      var variant =
        product.variants.filter(function (v) {
          return v.id === variantId;
        })[0] || product.variants[0];
      if (!variant) return;

      var qty = parseInt(quantityInputEl.value, 10);
      if (!qty || qty < 1) qty = 1;

      var el = ensureTotalElement(sectionId);
      if (!el) return;

      var valueEl = el.querySelector('.product-total-price__value');
      var noteEl = el.querySelector('.product-total-price__note');

      if (product.handle === BULK_QUOTE_HANDLE && qty >= BULK_QUOTE_THRESHOLD) {
        if (valueEl) valueEl.textContent = '';
        if (noteEl) noteEl.innerHTML = BULK_QUOTE_MESSAGE;
        return;
      }

      if (noteEl) noteEl.innerHTML = '';

      var formats = window.moneyFormats || {};
      var formatString = formats.currencyCodeEnabled ? formats.withCurrency : formats.standard;

      var subtotal = variant.price * qty;
      var percent = product.handle === BULK_QUOTE_HANDLE ? discountPercentFor(qty) : 0;
      var total = percent > 0 ? Math.round(subtotal * (1 - percent)) : subtotal;

      if (valueEl) {
        valueEl.textContent = formatMoney(total, formatString);
      }
      if (noteEl && percent > 0) {
        noteEl.textContent = Math.round(percent * 100) + '% bulk discount applied at checkout';
      }
    });
  }

  function handleEvent(e) {
    var input = e.target.closest && e.target.closest('.quantity__input');
    if (input) {
      updateTotal(input);
      return;
    }

    var variantInput = e.target.closest && e.target.closest('input[name="id"]');
    if (variantInput) {
      var productInfo = variantInput.closest('product-info');
      var qtyInput = productInfo ? productInfo.querySelector('.quantity__input') : null;
      if (qtyInput) updateTotal(qtyInput);
    }
  }

  document.addEventListener('change', handleEvent, true);
  document.addEventListener('input', handleEvent, true);

  function initAll(root) {
    (root || document).querySelectorAll('quantity-input[data-url] .quantity__input').forEach(updateTotal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('quantity-input[data-url]')) {
          var input = node.querySelector('.quantity__input');
          if (input) updateTotal(input);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('quantity-input[data-url] .quantity__input').forEach(updateTotal);
        }
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
